jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-card');
    const $triggers = $blocks.find('[data-overlay]');
    
    if ($blocks.length === 0) { return; }
    
    // Get scrollbar width to prevent layout shift
    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };
    
    // Side panel overlay functionality
    if ($triggers.length > 0) {
        $triggers.on('click', function(e) {
            e.preventDefault();
            
            const overlayId = $(this).data('overlay');
            const $overlay = $(overlayId);
            const scrollbarWidth = getScrollbarWidth();

            // Handle page and scroll - account for scrollbar width
            $('html').css('overflow', 'hidden');
            if (scrollbarWidth > 0) {
                $('body').css('margin-right', scrollbarWidth + 'px');
            }
    
            // Handle the panel with fade and slide animation
            $overlay.css({ display: 'block', opacity: '0' })
                    .animate({ opacity: 1 }, 300);
            
            const $panel = $overlay.find('.wp-block-jormi-card__panel');
            $panel.css({ 
                'transform': 'translateX(100%)',
                'opacity': '0'
            }).animate({ 
                opacity: 1 
            }, 300, 'swing');
            
            // Animate transform using CSS transition
            setTimeout(function() {
                $panel.css('transform', 'translateX(0)');
            }, 10);
            
            const $closeButton = $overlay.find('.wp-block-jormi-card__panel-close');
            $closeButton.one('click', function() {
                const $panel = $overlay.find('.wp-block-jormi-card__panel');
                $panel.animate({ opacity: 0 }, 250, function() {
                    $(this).css('transform', 'translateX(100%)');
                });
                $overlay.animate({ opacity: 0 }, 250, function() {
                    $overlay.css({display: 'none'});
                });
                $('html').css('overflow', 'auto');
                $('body').css('margin-right', '0');
            });
            
            $overlay.on('click', function(e) {
                if (e.target === this) {
                    const $panel = $overlay.find('.wp-block-jormi-card__panel');
                    $panel.animate({ opacity: 0 }, 250, function() {
                        $(this).css('transform', 'translateX(100%)');
                    });
                    $overlay.animate({ opacity: 0 }, 250, function() {
                        $overlay.css({display: 'none'});
                    });
                    $('html').css('overflow', 'auto');
                    $('body').css('margin-right', '0');
                    $(this).off('click');
                }
            });
        });
        
        $(document).on('keyup', function(e) {
            if (e.key === 'Escape') {
                $('html').css('overflow', 'auto');
                $('body').css('margin-right', '0');
            }
        });
    }

    // Accordion functionality
    const $accordionItems = $('.wp-block-jormi-card.acc-item');

    $accordionItems.find('.js-expander').on('click', function(e) {
        e.preventDefault();
        const $thisItem = $(this).closest('.acc-item');
        const $expander = $($thisItem).find('.wp-block-jormi-card__expander');

        if ($thisItem.hasClass('is-collapsed')) {
            // Close all other accordion items with animation
            $accordionItems.not($thisItem).each(function() {
                const $otherItem = $(this);
                const $otherExpander = $otherItem.find('.wp-block-jormi-card__expander');
                
                if ($otherItem.hasClass('is-expanded')) {
                    $otherExpander.slideUp(250, 'swing', function() {
                        $otherItem.removeClass('is-expanded').addClass('is-collapsed');
                    });
                } else {
                    $otherItem.addClass('is-inactive');
                }
            });
            
            // Slight delay for smoother sequential animation
            setTimeout(function() {
                $thisItem.removeClass('is-collapsed').addClass('is-expanded');
                $expander.slideDown(350, 'swing').addClass('is-visible');
            }, 100);

        } else {
            $thisItem.removeClass('is-expanded').addClass('is-collapsed');
            $expander.slideUp(250, 'swing').removeClass('is-visible');
            $accordionItems.not($thisItem).removeClass('is-inactive');
        }
    });

    $accordionItems.find('.js-collapser').on('click', function(e) {
        e.stopPropagation();
        
        const $thisItem = $(this).closest('.acc-item');
        const $expander = $thisItem.find('.wp-block-jormi-card__expander');
        
        $expander.slideUp(250, 'swing', function() {
            $thisItem.removeClass('is-expanded').addClass('is-collapsed');
            $accordionItems.not($thisItem).removeClass('is-inactive');
        });
    });
});